import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { changePeriodoEditingValue, changePeriodoEditingValuePanoramaCoop, changePeriodoEditingValuePanoramaFinancas } from "store/modules/EscolasActions";

export type PeriodoContexto = 'pufv' | 'coop' | 'financas';

export const useAtualizarPeriodoAtualDuplicacao = (duplicacao: boolean, contexto: PeriodoContexto) => {
    const escolas = useSelector((escolasState: RootState) => escolasState.escolas);
    const dispatch = useDispatch();

    type Periodo = {
        id: string;
        nomPeriodo: string;
    };

    const { periodoAtual, periodosList } = useSelector((): {
        periodoAtual: string;
        periodosList: Periodo[];
    } => {
        switch (contexto) {
            case 'coop':
                return {
                    periodoAtual: escolas.periodoEditingCoop.periodo,
                    periodosList: escolas.periodoEditingCoop.periodosList,
                };
            case 'financas':
                return {
                    periodoAtual: escolas.periodoEditingFinancas.periodo,
                    periodosList: escolas.periodoEditingFinancas.periodosList,
                };
            default:
                return {
                    periodoAtual: escolas.periodoEditing.periodo,
                    periodosList: escolas.periodoEditing.periodosList,
                };
        }
    });

    useEffect(() => {
        if (!duplicacao) return;
      
        const anoAtual = new Date().getFullYear().toString();
        const periodoStr = String(periodoAtual || '');
      
        if (!periodoStr.startsWith(anoAtual)) {
          const periodoDoAnoAtual = periodosList.find((p) =>
            p.nomPeriodo.startsWith(anoAtual)
          );
      
          if (periodoDoAnoAtual) {
            const valorPeriodo =
              contexto === 'coop' || contexto === 'financas'
                ? periodoDoAnoAtual.id
                : periodoDoAnoAtual.nomPeriodo;
      
            switch (contexto) {
              case 'coop':
                dispatch(changePeriodoEditingValuePanoramaCoop('periodo', valorPeriodo));
                break;
              case 'financas':
                dispatch(changePeriodoEditingValuePanoramaFinancas('periodo', valorPeriodo));
                break;
              case 'pufv':
              default:
                dispatch(changePeriodoEditingValue('periodo', valorPeriodo));
                break;
            }
          }
        }
      }, [dispatch, duplicacao, contexto, periodoAtual, periodosList]);
      
};
